import { render, staticRenderFns } from "./DiscussBtn.vue?vue&type=template&id=de1aa368&scoped=true&"
import script from "./DiscussBtn.vue?vue&type=script&lang=js&"
export * from "./DiscussBtn.vue?vue&type=script&lang=js&"
import style0 from "./DiscussBtn.vue?vue&type=style&index=0&id=de1aa368&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1aa368",
  null
  
)

export default component.exports